import { useEffect, useState } from 'react';
import { BANNER_TYPES, DSBanner } from '@elliemae/ds-banner';
import { getAppConfigValue } from '@elliemae/pui-app-sdk';

export const EnvNotificationHeader = () => {
  const ENV_NAME = (getAppConfigValue('activeEnv') as string).toUpperCase();
  const [isOpen, setOpen] = useState(ENV_NAME !== 'PROD');

  useEffect(() => {
    setOpen(ENV_NAME !== 'PROD');
  }, [ENV_NAME]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    isOpen && (
      <DSBanner
        containerProps={{ id: 'environment-notification-banner' }}
        isOpen={isOpen}
        label={`${ENV_NAME} Environment`}
        type={BANNER_TYPES.INFO}
        onClose={handleClose}
      />
    )
  );
};
